import React, { useState, useEffect } from 'react';
import { ChoferesService } from '../services/choferesService';
import FormularioChoferes from './FormularioChoferes';
import './GestionChoferesGerente.css';

const GestionChoferesGerente = () => {
  const [choferes, setChoferes] = useState([]);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);

  useEffect(() => {
    const unsubscribe = ChoferesService.suscribirseChoferes(setChoferes);
    return () => unsubscribe();
  }, []);

  const estadisticas = {
    total: choferes.length,
    activos: choferes.filter(c => c.estado === 'activo').length,
    inactivos: choferes.filter(c => c.estado === 'inactivo').length,
    suspendidos: choferes.filter(c => c.estado === 'suspendido').length
  };

  return (
    <div className="gestion-choferes-gerente">
      {/* Estadísticas */}
      <div className="stats-section">
        <div className="stat-card">
          <h3>Total Choferes</h3>
          <div className="stat-number">{estadisticas.total}</div>
        </div>
        <div className="stat-card">
          <h3>Activos</h3>
          <div className="stat-number activos">{estadisticas.activos}</div>
        </div>
        <div className="stat-card">
          <h3>Inactivos</h3>
          <div className="stat-number inactivos">{estadisticas.inactivos}</div>
        </div>
        <div className="stat-card">
          <h3>Suspendidos</h3>
          <div className="stat-number suspendidos">{estadisticas.suspendidos}</div>
        </div>
      </div>

      {/* Formulario de Choferes */}
      <FormularioChoferes />
    </div>
  );
};

export default GestionChoferesGerente;
